import { SERVICES, TONES, IMAGES } from "@/data/content";
import { PageHero } from "@/components/PageHero";
import { CtaBanner } from "@/components/CtaBanner";
import { ServiceSection } from "@/components/services/ServiceSection";
import { SERVICE_ICONS } from "@/components/home/ServicesTeaser";

const AnchorNav = () => (
  <div className="sticky top-[84px] z-30 -mt-4 px-3 sm:px-6" data-testid="services-anchor-nav">
    <div className="mx-auto max-w-7xl glass rounded-2xl px-3 py-2.5 flex gap-2 overflow-x-auto no-scrollbar">
      {SERVICES.map((s) => {
        const Icon = SERVICE_ICONS[s.icon];
        const t = TONES[s.tone];
        return (
          <a
            key={s.id}
            href={`#${s.id}`}
            data-testid={`services-anchor-${s.id}`}
            className="group inline-flex shrink-0 items-center gap-2 rounded-full border border-transparent px-3.5 py-2 text-[12px] font-medium text-[#3B4A5E] hover:bg-white hover:border-[#0E1B31]/10 transition-colors"
          >
            <span className="flex h-6 w-6 items-center justify-center rounded-full text-white" style={{ background: t.accent }}>
              <Icon className="h-3 w-3" />
            </span>
            <span className="font-mono-brand text-[10px] text-[#6B7A8F]">{s.num}</span>
            <span className="hidden sm:inline">{s.title}</span>
          </a>
        );
      })}
    </div>
  </div>
);

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        testId="services-hero"
        eyebrow="Υπηρεσίες"
        tone="#2C4A6F"
        image={IMAGES.engineer}
        title={
          <>
            Έξι άξονες δουλειάς. Ένας στόχος: <span className="italic text-[#2C4A6F]">μετρήσιμη ανάπτυξη.</span>
          </>
        }
        desc="Από την αύξηση των πωλήσεων και την είσοδο σε νέες αγορές, έως την οργάνωση της λειτουργίας και την πρακτική αξιοποίηση του AI — κάθε άξονας δουλεύει μόνος του ή συνδυαστικά."
      />

      <AnchorNav />

      <div className="mt-6">
        {SERVICES.map((s, idx) => (
          <ServiceSection key={s.id} s={s} idx={idx} />
        ))}
      </div>

      <CtaBanner
        title="Δεν ξέρετε από πού να ξεκινήσετε;"
        subtitle="Ξεκινάμε πάντα με ανάλυση: κατανοούμε πρώτα την επιχείρηση και την αγορά σας, μετά προτείνουμε."
        buttonLabel="Ας μιλήσουμε για την επιχείρησή σας"
      />
    </div>
  );
}
